import { getUserUniqueQueryKey } from '@/helpers/auth';

const f = getUserUniqueQueryKey;

export const QUERY_KEYS = {
  CHURCH_BASE_QUERY_KEY: 'church',
  CHURCH_PRODUCTS: f('church-products'),
  CHURCHES: f('churches'),
  CHURCH: f('church'),
  CHURCH_CMS_BLOCKS: f('church-cms-blocks'),
  CHURCH_CUSTOM_CMS_BLOCKS: f('custom-cms-blocks'),
  GROUPS: f('groups'),
  GROUP: f('group'),
  MINISTRY_GROUPS: f('ministry-groups'),
  MINISTRY_GROUP: f('ministry-group'),
  MINISTRY_GROUP_ADMINS: f('ministry-group-admins'),
  MINISTRY_GROUP_PARENT_CANDIDATES: f('ministry-group-parent-candidates'),
  MINISTRY_CALENDAR_LOOKUP: f('ministry-calendar-lookup'),
  MINISTRY_LOCATION_LOOKUP: f('ministry-location-lookup'),
  MINISTRY_VOLUNTEERS: f('ministry-volunteers'),
  MINISTRY_VOLUNTEER: f('ministry-volunteer'),
  MINISTRY_VOLUNTEER_CANDIDATES: f('ministry-volunteer-candidates'),
  MINISTRY_CHURCH_DIRECTORY: f('ministry-church-directory'),
  GROUP_BASIC_INFO: f('group-basic-info'),
  GROUP_SHARE_OPTIONS: f('group-share-options'),
  GROUP_ADMINS: f('group-admins'),
  GROUP_LIST_ADMINS: f('group-list-admins'),
  GROUP_SETTINGS: f('group-settings'),
  MEMBER: f('member'),
  MEMBERS: f('members'),
  MEMBERS_IMPORT_CURRENT: f('members-import-current'),
  FORMS_LIST: f('forms-list'),
  FORM: f('form'),
  FORMS_TEMPLATES_LIST: f('form-templates'),
  MESSAGE: f('message'),
  MESSAGE_RECIPIENTS_INFO: f('message-recipients-info'),
  MESSAGE_STATISTICS: f('message-statistics'),
  MESSAGE_CLICK_REPORT: f('message-click-report'),
  MESSAGE_DELIVERY_REPORT: f('message-delivery-report'),
  MESSAGES: f('messages'),
  MESSAGE_REPLIES: f('message-replies'),
  ANNOUNCEMENT_MESSAGES: 'announcementMessages',
  USER: f('user'),
  CHURCH_ADMIN_CURRENT_SCOPES: f('church-admin-current-scopes'),
  CHURCH_ADMINS: f('church-admins'),
  CALENDAR: f('calendar'),
  CALENDARS: f('calendars'),
  CALENDAR_EVENTS: f('calendar-events'),
  CALENDAR_EVENT_LITURGIES: f('calendar-event-liturgies'),
  CALENDAR_EVENT_LOCATIONS: f('calendar-event-locations'),
  CALENDAR_EVENT_LOCATION_LOOKUP: f('calendar-event-location-lookup'),
  CALENDAR_EVENT_LANGUAGES: f('calendar-event-languages'),
  CALENDAR_CHURCH_OPTIONS: f('calendar-church-options'),
  DIRECTORY_ROLES: f('directory-roles'),
  MASS_TIMES: f('mass-times'),
  BACKGROUND_IMAGES: f('background-images'),
  PAYMENT_METHODS: f('payment-methods'),
  PURCHASES: f('purchases'),
  PRICE_CATALOG: f('price-catalog'),
  TEXT_CREDITS: f('text-credits'),
  SMS_STATISTIC: f('sms-statistic'),
  CHURCH_CONTEXT_BULLETINS: f('church-context-bulletins'),
  CHURCH_CONTEXT_READINGS: f('church-context-readings'),
  CHURCH_CONTEXT_INSPIRATIONS: f('church-context-inspirations'),
  CHURCH_CONTEXT_PRAYERS: f('church-context-prayers'),
  CHURCH_CONTEXT_ANNOUNCEMENT_MESSAGE: f('church-context-announcement-message'),
  CHURCH_SUGGESTED_MODULES: f('church-suggested-modules'),
  ADMIN_PRODUCT_CONTEXT: f('admin-product-context'),
  DASHBOARD_NOTIFICATIONS: f('dashboard-notifications'),
  DASHBOARD_FAVORITE_CHURCHES_COUNT: f('dashboard-favorite-churches-count'),
  BULLETINS: f('admin-bulletins'),
  BULLETIN: f('admin-bulletin'),
  PRAYERS: f('admin-prayers'),
  PRAYER: f('admin-prayer'),
  COMMUNITY_CARDS: f('community-cards'),
  COMMUNITY_CARD: f('community-card'),
  COMMUNITY_LIST_CARDS: f('community-list-cards'),
  COMMUNITY_LIST: f('community-list'),
  COMMUNITY_LISTS: f('community-lists'),
  COMMUNITY_CAMINO_SYNC_STATUS: f('community-camino-sync-status'),
  COMMUNITY_LIST_CAMINO_SYNC_STATUS: f('community-list-camino-sync-status'),
  COMMUNITY_IMPORT_CURRENT: f('community-import-current'),
  COMMUNITY_IMPORT_STATUS: f('community-import-status'),
};
